import { Link } from "react-router-dom";

import { Container, Grid } from "semantic-ui-react"

export function CallToActionBlurbs() {
  return (
    <>
      <div className="callToActionContainer">
        <Container>
          <Grid>
            <Grid.Row>
              <Grid.Column width={5}>
                <span className="landingTagLine charcoal">Train a Narrator</span><br />
                <span className="charcoal">Be a narrator</span>
                <br />
                <Link to="/" ><span className="charcoal">Join the Stable</span></Link>
              </Grid.Column>
              <Grid.Column width={5}>
                <span className="landingTagLine charcoal">Stable of Actors</span><br />
                <Link to="/" ><span className="charcoal">Listen to Actors</span></Link>
              </Grid.Column>
              <Grid.Column width={5}>
                <span className="landingTagLine charcoal">Polish The Words</span><br />
                <span className="charcoal">Magic Voices</span><br />
                <Link to="/" ><span className="charcoal">Press go when it is just right</span></Link>
              </Grid.Column>
            </Grid.Row>
            {/* <Grid.Row><Grid.Column>
              <Button className="subTitleLearnMoreBtn" basic color="yellow" size="large" >Sign up</Button>
            </Grid.Column></Grid.Row> */}
          </Grid>
        </Container>
      </div>
    </>
  )
}
